import React from 'react'
import BlogItems from './BlogItems'
import { getNews } from '../contentful'
import TitleBar from './TitleBar'
import { Helmet } from 'react-helmet'

class Posts extends React.Component {
  state = {
    posts: []
  }


  componentDidMount() {
    getNews()
      .then(data => this.setState({ posts: data }))
  }



  render() {
    return (
      <>
        <Helmet>
          <title>Lucille Graham Trust || Previous Projects </title>
          <meta
            name="description"
            content="Many musical organisations have been suported by The Lucille Graham Trust, including orchestras, opera and theatre groups."
          />
          <link
            rel="canonical"
            href="https://www.lucillegrahamtrust.org.uk/news"
          />
        </Helmet>
        <TitleBar title="Previous Grants" />
        <div className='content'>
          <BlogItems posts={this.state.posts} />
          <br />

        </div>
      </>
    )
  }
}
export default Posts